import Page from './page';

export default Page;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/page/index.js